







































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse, Pagination } from '@/components/types';
import ErrorAlert from '@/components/ErrorAlert.vue';
import AppTable from '@/components/AppTable.vue';
import { FETCH_COUNTER_ACCOUNTS, GET_COUNTER_ACCOUNTS } from "../store";
import { CounterAccount } from "../types";
import CreateCounterAccountDialog from "@/modules/accounting/components/CreateCounterAccountDialog.vue";
import UpdateCounterAccountDialog from "@/modules/accounting/components/UpdateCounterAccountDialog.vue";
import DeleteCounterAccountDialog from "@/modules/accounting/components/DeleteCounterAccountDialog.vue";

const AccountingStore = namespace('accounting');

@Component({
  components: {
    DeleteCounterAccountDialog,
    UpdateCounterAccountDialog,
    CreateCounterAccountDialog,
    AppTable,
    ErrorAlert
  }
})
export default class CounterAccountTable extends Vue {
  @AccountingStore.Getter(GET_COUNTER_ACCOUNTS) list!: Account[];
  @AccountingStore.Action(FETCH_COUNTER_ACCOUNTS) fetch!: () => Promise<ApiResponse<Account[]>>;

  error: any = null;
  loading: boolean = false;
  editAccount: CounterAccount | null = null;
  deleteAccount: CounterAccount | null = null;

  pagination: Pagination = {
    sortBy: ['code'],
    itemsPerPage: -1
  };

  get headers() {
    return [
      { align: 'left', text: this.$i18n.t('common.financialState'), value: 'financialState' },
      { align: 'left', text: this.$i18n.t('accounting.counterCode'), value: 'code' },
      { align: 'left', text: this.$i18n.t('common.actions'), value: null, sortable: false, width: '140px' }
    ];
  }

  async created() {
    this.loading = true;
    this.error = null;

    const { error } = await this.fetch();

    this.loading = false;

    if (error) {
      this.error = error;
    }
  }
}
